<template
  xmlns:v-slot="http://www.w3.org/1999/XSL/Transform"
  xmlns:v-clipboard="http://www.w3.org/1999/xhtml"
>
  <div class="row">
    <div class="col-12 mb-4">
      <v-alert type="info">
        {{ $t("webhook.webhook_info") }}
      </v-alert>
      <v-card>
        <h5 style="font-weight: 200">{{ $t("webhook.webhook_management") }}</h5>
        <v-spacer></v-spacer>
        <div class="col-12 p-0 m-0">
          <div class="row">
            <div class="col-6">
              <v-text-field
                solo
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </div>
            <div class="col-6 text-right" v-if="filteredHooks.length > 0">
              <v-btn color="default" dark class="mb-2" @click="dialog = true">{{
                $t("webhook.new_webhook")
              }}</v-btn>
            </div>
          </div>
        </div>
        <v-data-table
          :headers="headers"
          :items="webhooks"
          :search="search"
          :loading="webhooks === undefined"
          loading-text="Chargement en cours..."
          sort-by="label"
          class="elevation-0 pt-0 mt-0"
        >
          <template v-slot:item._file="{ item }">
            <a :href="item._file">{{ getFileOriginalName(item._file) }}</a>
          </template>
          <template v-slot:item._event="{ item }">
            <v-chip class="ma-2">
              {{ item._event }}
            </v-chip>
          </template>
          <template v-slot:item._secret="{ item }">
            <div class="container">
              <a
                href="#"
                data-toggle="tooltip"
                data-placement="right"
                style="
                  cursor: pointer;
                  background-color: #f5f6fe;
                  padding: 8px;
                  color: black;
                  border-radius: 10px !important;
                  text-decoration: none;
                "
                v-clipboard:copy="item._secret"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <v-icon style="color: #3c3c3c" small
                  >mdi mdi-content-copy</v-icon
                >
              </a>
            </div>
          </template>

          <template v-slot:item._created_at="{ item }">
            {{ new Date(item._created_at).toLocaleDateString() }}
          </template>
          <template v-slot:item.action="{ item }">
            <div class="text-right">
              <v-btn
                @click="deleteWebhook(item._id)"
                text
                color="pink"
                fab
                class="mb-0"
                small
              >
                <v-icon dark>mdi-trash-can-outline</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-if="!webhooks || (webhooks && webhooks.length < 14)">
            <v-toolbar flat color="white">
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <!-- <template v-slot:item.actions="{ item }">
                        <div style="text-align:  right">
                            <v-menu
                                    key="text"
                                    rounded="b-xl">
                                <template v-slot:activator="{ attrs, on }">

                                    <v-icon

                                            class="black&#45;&#45;text "
                                            v-bind="attrs"
                                            v-on="on">mdi-dots-vertical</v-icon>

                                </template>
                                <v-list>
                                    <v-list-item  @click="editItem(item)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6"> mdi-pencil
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>

                                            <v-list-item-title >
                                                Modifier
                                            </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>
                                    <v-list-item  @click="description(item)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">  mdi-eye
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>

                                            <v-list-item-title>
                                                Description
                                            </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>

                    </template>-->
          <template v-slot:no-data>
            {{ $t("no_data") }}
          </template>
        </v-data-table>
      </v-card>

      <v-dialog
        v-model="dialog"
        max-width="500"
        v-if="filteredHooks.length > 0"
      >
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-text-field
              v-if="submitting"
              color="primary"
              loading
              disabled
            ></v-text-field>

            <v-alert v-if="errors.operation" dense outlined type="error">
              {{ errors.operation }}
            </v-alert>
            <v-form
              ref="form"
              v-model="valid"
              :lazy-validation="lazy"
              enctype="multipart/form-data"
            >
              <v-row>
                <v-alert type="warning">
                  {{ $t("webhook.warning_url") }}
                </v-alert>

                <v-col cols="12" sm="12">
                  <v-text-field
                    solo
                    small
                    :rules="urlRule"
                    v-model="editedItem._url"
                    :label="$t('webhook.url')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12">
                  <span style="font-size: 18px">{{ $t("webhook.event") }}</span>
                  <div>
                    <v-radio-group v-model="event">
                      <v-radio
                        v-for="(hook, index) in filteredHooks"
                        :key="index"
                        :label="`${hook.name}`"
                        :value="hook.value"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" st>
                  <v-text-field
                    solo
                    small
                    :rules="secreRule"
                    v-model="editedItem._secret"
                    :label="$t('webhook.secret')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <input type="hidden" :value="marchandu._id" />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="dark" @click.prevent="close">{{
              $t("cancel")
            }}</v-btn>
            <v-btn
              color="primary"
              :disabled="!valid || mis"
              @click.prevent="save"
              >{{ $t("save") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <customsnackbar
        :snackbar="customSnack.snackbar"
        :text="customSnack.text"
        :snackcolor="customSnack.snackcolor"
        :snackbBtnColor="customSnack.snackbBtnColor"
        :snacktimeout="customSnack.snacktimeout"
      >
      </customsnackbar>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as Swal from "sweetalert2";
import helpers from "../../../../../mixins/helpers";
export default {
  name: "Webhook",
  mixins: [helpers(this)],
  data() {
    return {
      hooks: [
        { name: this.$t("webhook.paiement_reuissi"), value: "success" },
        { name: this.$t("webhook.paiement_echoue"), value: "error" },
        { name: this.$t("webhook.intram_direct"), value: "intram_direct" },
        { name: this.$t("webhook.intram_business"), value: "intram_business" },
      ],
      submitting: false,
      valid: true,
      lazy: false,
      mis: false,
      event: "success",
      errors: {},
      customSnack: {
        snackbar: false,
        text: "",
        snackcolor: "black",
        snackbBtnColor: "white",
        snacktimeout: 2000,
      },
      search: "",
      desc: "",
      dialog3: false,
      dialog: false,
      id: undefined,
      available_hooks: [],
      headers: [
        { text: this.$t("webhook.url"), value: "_url" },
        { text: this.$t("webhook.event"), value: "_event" },
        { text: this.$t("webhook.secret"), value: "_secret" },
        { text: this.$t("date"), value: "_created_at" },
        { text: "", value: "action" },
        /*
                    { text: '', value: 'actions', sortable: false },
*/
      ],
      editedIndex: -1,
      editedItem: {
        _url: "",
        _secret: "",
        _event: ["success"],
        _created_at: 0,
        _id: "",
      },
      defaultItem: {
        url: "",
        _secret: "",
        _event: ["success"],
        _created_at: 0,
        _id: "",
      },
      urlRule: [
        (v) => !!v || this.$t("webhook.url_requis"),
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      secreRule: [(v) => !!v || this.$t("webhook.secret_requis")],
      eventRule: [(v) => !!v || this.$t("webhook.event_requis")],
      fileRules: [(v) => !!v || this.$t("file_required")],
    };
  },
  computed: {
    filteredHooks() {
      return this.hooks.filter(
        (hook) => !this.available_hooks.includes(hook.value)
      );
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("webhook.new_webhook")
        : this.$t("webhook.update_webhook");
    },
    ...mapState("webhooks/", ["webhooks"]),
    ...mapState("marchands/", ["marchandu"]),
  },
  mounted() {
    let marchand = this.$store.getters.marchand;
    this.$store.dispatch("webhooks/get", marchand._id).then((response) => {
      response.webhooks.forEach((webhook) => {
        this.available_hooks.push(webhook._event);
      });
    });
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    onCopy: function (e) {
      this.text = this.$t("copie") + e.text;
      this.snackbar = true;
    },
    onError: function () {
      this.text = this.$t("copiefailed");
      this.snackbar = true;
    },
    showdescription(vdes) {
      this.desc = vdes;
      this.dialog3 = true;
    },
    editItem(item) {
      this.editedIndex = this.webhooks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.id = item._id;
    },

    description(item) {
      Swal.fire({
        title: this.$t("description"),
        timerProgressBar: false,
        text: item._description,
        confirmButtonText: "Oui",
        confirmButtonColor: "#29B3A6",
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.reset();
    },
    deleteWebhook(id) {
      let v_box = this;
      Swal.fire({
        icon: "warning",
        title: "Êtes vous sur ?",
        text: "Ête vous sur de vouloir supprimer ce webhook ?",
        confirmButtonText: "Oui",
        confirmButtonColor: "#29B3A6",
        showCancelButton: true,
        cancelButtonText: "Non",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          v_box.$store.dispatch("webhooks/delete", id).then((response) => {
            console.log(response.webhooks, "******* delete webhooks");
            v_box.available_hooks = [];
            response.webhooks.forEach((webhook) => {
              v_box.available_hooks.push(webhook._event);
            });
            console.log(v_box.available_hooks, "******************");
            Swal.fire({
              position: "top-end",
              timerProgressBar: true,
              icon: "success",
              timer: 1500,
              text: "Webhook supprimer avec succès !",
              showConfirmButton: false,
            });
          });
        }
      });
    },
    save() {
      this.customSnack.snackbar = false;
      this.mis = true;
      let data = new FormData();
      data.append("url", this.editedItem._url);
      data.append("secret", this.editedItem._secret);
      data.append("event", this.event);
      data.append("marchand", this.marchandu._id);
      data.append("success", this.event.includes("success") ? true : false);
      data.append("error", this.event.includes("error") ? true : false);
      if (this.id) data.append("id", this.id);
      this.submitting = true;
      this.$store.dispatch("webhooks/set", data).then((response) => {
        this.submitting = false;
        if (response.error) {
          this.errors.operation = response.message;
        } else {
          this.available_hooks = [];
          response.webhooks.forEach((webhook) => {
            this.available_hooks.push(webhook._event);
          });
          this.close();
          this.showSnackDefault(response);
        }
      });
      this.mis = false;
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.event = "success";
      this.editedItem = {
        _url: "",
        _secret: "",
        _event: "success",
        _created_at: 0,
        _id: "",
      };
    },
    checkisDashboard() {
      this.$emit("checkisDashboard", true);
    },
    fileChange() {
      console.log(this.$refs);
      this.editedItem._file = this.$refs.file.files[0];
    },
    getFileOriginalName(file) {
      return file.substr(file.lastIndexOf("/") + 1);
    },
  },
  created() {
    this.checkisDashboard();
  },
};
</script>

<style scoped></style>
